import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarSolicitante } from './types';

export const INITIAL_STATE: ConsultarSolicitante = {
	tipoVinculo: null,
	status: 0,
	data: null,
	form: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarSolicitante {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPO_VINCULO_SOLICITANTE: {
				draft.tipoVinculo = action.payload;
				break;
			}

			case Types.CONSULTAR_SOLICITANTE_REQUEST: {
				draft.form = action.payload;
				break;
			}
			case Types.CONSULTAR_SOLICITANTE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTAR_SOLICITANTE_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_SOLICITANTE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.form = INITIAL_STATE.form;
				draft.tipoVinculo = INITIAL_STATE.tipoVinculo;
				break;
			}

			default:
		}

		return draft;
	});
}
